import styles from '@/components/help/common/FormContainer/FormContainer.module.scss';
import {ROUTE} from '@/constants/main/route';
import {useNavigate} from 'react-router-dom';
import {useFormContext} from 'react-hook-form';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {SoopButtonCommon} from '@soop-ui/soop-ui';
import {useFormLabels} from '@/hooks/help/useFormLabels';

const ActionButtons = () => {
  const navigate = useNavigate();
  const {submit: submitText} = useFormLabels();
  const {
    formState: {isValid},
  } = useFormContext();
  const {isMobile} = useHelpContext();

  // 고객센터 메인으로 이동
  const handleCancel = () => {
    navigate(ROUTE.HELP.INDEX);
  };

  return (
    <div className={styles.btnArea}>
      {/* isMobile이 true일 때만 '취소' 버튼 렌더링 */}
      {isMobile && (
        <SoopButtonCommon
          type='button'
          className={styles.cancelButton}
          variant='lineSecondary'
          size={44}
          onClick={handleCancel}>
          취소
        </SoopButtonCommon>
      )}
      <SoopButtonCommon
        type='submit'
        className={styles.submitButton}
        variant='defaultPrimary'
        disabled={!isValid}
        size={isMobile ? 44 : 52}>
        {submitText}
      </SoopButtonCommon>
    </div>
  );
};

export default ActionButtons;
